<template>
    <div>
        <alerts :status="alert" v-model="alert"></alerts>
        <div id="create_workflow" class="collapse">
            <div class="form-horizontal throttle">
                <div class="max-w-xl">
                    <div class="mt-0 pt-4 pb-2 mb-4 d-flex flex-column">
                        <label for="name" class="col-form-label">Name</label>
                        <div>
                            <input id="name" type="text" v-model="form.name" class="form-control">
                        </div>
                    </div>
                    <div class="mt-0 py-0 mb-4 d-flex flex-column">
                        <label for="desc" class="col-form-label">Description</label>
                        <div>
                            <textarea id="desc" v-model="form.description" rows="2" class="form-control"></textarea>
                        </div>
                    </div>
                    <div class="mt-0 py-0 mb-4 d-flex flex-column">
                        <label for="desc" class="col-form-label">Add Project(s)</label>
                        <div>
                            <vuetable
                                ref="vuetable"
                                :api-url="apiURL"
                                :fields="fields"
                                :css="css.table"
                                :per-page="4"
                                :append-params="moreParams"
                                pagination-path="pagination"
                                noDataTemplate="No Projects Found"
                                @vuetable:pagination-data="onPaginationData"
                                @vuetable:loaded="onLoaded"
                                @vuetable:checkbox-toggled="onCheckbox"
                                @vuetable:checkbox-toggled-all="onCheckboxAll"
                            >
                                <template slot="name" slot-scope="props">
                                    {{ props.rowData.name }}
                                </template>
                                <template slot="actions" slot-scope="props">
                                    <div class="btn-group">
                                        <a class="btn btn-sm btn-outline-secondary" :href="`/projects/${props.rowData.id}/edit`">
                                            <i class="fa fa-eye"></i>
                                        </a>
                                    </div>
                                </template>
                            </vuetable>
                            <div class="row d-flex justify-content-between align-items-center w-100 m-auto pb-2">
                                <span>
                                    <base-pagination-info
                                        :css="css.table"
                                        ref="paginationInfo"
                                    ></base-pagination-info>
                                </span>
                                <span>
                                    <base-pagination
                                        ref="pagination"
                                        @vuetable-pagination:change-page="onChangePage"
                                    ></base-pagination>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="mt-0 py-0 mb-4 d-flex flex-column">
                        <div class="d-flex flex-column">
                            <div class="mb-1">
                                <button class="btn btn-link text-muted px-0 d-flex" @click.prevent="openRestrictUserModal">
                                    Restrict to Users +
                                </button>
                            </div>
                            <div>
                                <button type="button" class="btn btn-secondary" data-toggle="collapse" data-target="#create_workflow">
                                    Cancel
                                </button>
                                <button class="btn btn-primary" type="submit" @click.prevent="handleCreateWorkflow" :disabled="!form.name.length">
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="restrictUserModal" class="modal-wrapper">
                <div class="modal-bg" @click.prevent="restrictUserModal = false"></div>
                <workflow-restrict-user :pending-users="pendingWorkflowUsers" :pending-roles="pendingWorkflowRoles"></workflow-restrict-user>
            </div>
        </div>
    </div>
</template>
<style scoped>
.pending-projects-list {
    border: 1px solid #dedede;
    overflow-y: scroll;
    max-height: 24vh;
    height: 100%;
}

.checkbox-title {
    width: 14%;
}
</style>
<script>
import axios from 'axios'
import SelectItemFromAPIprovidedList from "../generic/select-item-from-api-provided-list.vue";
import WorkflowRestrictUser from "./workflow-restrict-user.vue";
import ProductAlerts from "../products/product-details-alerts.vue";
import BasePagination from "../tables/base-pagination.vue";
import BasePaginationInfo from "../tables/base-pagination-info.vue";

const base_url = window.location.protocol + "//" + window.location.host;

export default {
    name: "create-workflow-form",
    data() {
        return {
            loading: true,
            restrictUserModal: false,
            createWorkflowModal: false,
            pendingWorkflowUsers: [],
            pendingWorkflowRoles: [],
            availableWorkflowRoles: [],
            apiURL: "/pimapi/projects",
            selectedProject: {},
            pendingProjects: [],
            alert: {
                message: "",
                status: "",
                timeOut: 15000,
            },
            form: {
                name: '',
                description: ''
            },
            moreParams: {},
            fields: [
                {
                    name: "__checkbox",
                    titleClass: 'center aligned checkbox-title',
                    dataClass: 'right aligned'
                },
                {
                    name: "__slot:name",
                    title: "Name",
                },
                {
                    name: "__slot:actions",
                    titleClass: "actions-single-column",
                },
            ],
            css: {
                table: {
                    tableClass:
                        "table table-striped table-bordered table-middle",
                    ascendingIcon: "sort-icon-asc",
                    descendingIcon: "sort-icon-desc",
                    infoClass: "",
                },
            },
        }
    },
    components: {
        "selection-lister": SelectItemFromAPIprovidedList,
        "workflow-restrict-user": WorkflowRestrictUser,
        "alerts": ProductAlerts,
        "base-pagination": BasePagination,
        "base-pagination-info": BasePaginationInfo,
    },
    computed: {
        pendingProjectIds() {
            return this.pendingProjects.map((p) => p.id);
        },
        canManageWorkflow() {
            return this.$root.enabledPermissions.includes('manage_workflow');
        }
    },
    methods: {
        clearTable() {
            this.pendingProjects = [];
            this.$refs.vuetable.selectedTo = [];
            this.$refs.vuetable.refresh();
        },
        onPaginationData(paginationData) {
            this.$refs.pagination.setPaginationData(paginationData);
            this.$refs.paginationInfo.setPaginationData(paginationData);
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },
        onLoaded: function () {
            this.loading = false;

        },
        onCheckbox(isChecked, row) {
            if (isChecked) {
                this.pendingProjects.push(row);
            } else {
                this.pendingProjects = this.pendingProjects.filter((pendingProject) => pendingProject.id !== row.id)
            }
        },
        onCheckboxAll(isChecked) {
            if (isChecked === false) {
                this.$refs.vuetable.selectedTo = [];
                this.pendingProjects = [];
            } else {
                let selected = this.$refs.vuetable.tableData.map(item => item);
                this.pendingProjects = this.pendingProjects.concat(selected);
            }
        },
        handlePendingProject() {
            if (!this.pendingProjectIds.includes(this.selectedProject.id)) {
                this.pendingProjects.push(this.selectedProject);
            } else {
                this.alert = {
                    message: 'Project is already pending.',
                    status: "alert-warning"   
                }
            }
        },
        removePendingProject(id) {
            this.pendingProjects = this.pendingProjects.filter((p) => p.id !== id);
        },
        handleSelectProject(project) {
            this.selectedProject = project;
        },
        handleCreateWorkflow() {
            this.loading = true;
            
            const payload = {
                name: this.form.name,
                description: this.form.description,
            };  

            if (this.pendingProjects.length) {
                payload.projects = this.pendingProjectIds;
            }

            if (this.pendingWorkflowUsers.length) {
                payload.userIds = this.pendingWorkflowUsers.map((u) => u.id);
            }

            if (this.pendingWorkflowRoles.length) {
                payload.roleIds = this.pendingWorkflowRoles.map((r) => r.id);
            }

            axios.post(base_url + '/pimapi/workflows', payload)
                .then(function (response) {
                    this.loading = false;
                    this.createWorkflowModal = false;
                    this.pendingProjects = [];
                    this.pendingWorkflowUsers = [];
                    
                    this.form = {
                        name: '',
                        description: ''
                    };


                    this.alert = {
                        message: 'Success, workflow created',
                        status: "alert-success"   
                    }

                    this.$root.$emit('refresh-workflows-listing');
                }.bind(this))
                .catch(function (error) {
                    console.log(error);
                    this.loading = false;

                    this.alert = {
                        message: error.response.data.message,
                        status: "alert-danger"   
                    }
                }.bind(this));
        },
        openRestrictUserModal() {
            this.restrictUserModal = true;
        },
        transform(data) {
            const transformed = {};
            
            transformed.pagination = {
                total: data.total,
                per_page: data.per_page,
                current_page: data.current_page,
                last_page: data.last_page,
                next_page_url: data.next_page_url,
                prev_page_url: data.prev_page_url,
                from: data.from,
                to: data.to
            };

            transformed.data = data.data;

            return transformed
        }
    }
};
</script>       